export default __webpack_public_path__ + "static/media/template_pro__0016_11---WailoengChan.a6a137ef.png";